import axios from "axios";
// import {  MessageBox, Message } from "element-ui";
import store from "../store/store";
import Vue from 'vue'
import router from '@/router'
axios.defaults.timeout = 20000
axios.defaults.withCredentials = true
/* 创建axios实例 */
const service = axios.create({
  // headers: {
  //   "Content-Type": "application/json;charset=utf-8",
  // },
  baseURL: process.env.VUE_APP_BASE_URL,
});

/* 拦截器 */
try {
  service.interceptors.request.use(
    (config) => {
      const token = store.state.token;
      if (token) config.headers["Authorization"] = token;
      return config;
    },
    (error) => {
      Vue.prototype.$toast('加载超时')
      Promise.reject(error);
    }
  );
}catch (err){
  console.log(err)
}

/* 响应拦截器 */
// try{
//   service.interceptors.response.use(
//     (res) => {
//       // console.log(res)
//       const code = res.data.code;
//       if (code === 401) {
//         MessageBox.confirm(
//           "登录状态已过期，您可以继续留在该页面，或者重新登录",
//           "系统提示",
//           {
//             confirmButtonText: "重新登录",
//             cancelButtonText: "取消",
//             type: "warning",
//           }
//         ).then(() => {
//           store.dispatch("LogOut").then(() => {
//             location.reload(); // 为了重新实例化vue-router对象 避免bug
//           });
//         });
//       } else if (code !== 0) {
//         if(code === 110){
//           Vue.prototype.$toast(res.data.msg)
//         }
//         return Promise.reject("error");
//       } else {
//         return res.data;
//       }
//     },
//     (error) => {
//         // Message({
//         //     message: error.message,
//         //     type: 'error',
//         //     duration: 5 * 1000
//         // })
//         return Promise.reject(error)
//     }
//   );
// }catch (err){
//   console.log(err)
// }
try {
  service.interceptors.response.use(
    data => {
      // 停机维护
      if (data.data.code === 9999) {
        store.commit('setStopServerTime', data.data.data)
        return Promise.reject(data.data.msg)
      } else {
        store.commit('setStopServerTime', null)
      }
      // 排队机制
      if (data.data.code === 10) {
        let websocket = Vue.prototype.$websocket
        if (websocket.isConnect) {
          Vue.prototype.$websocket.getLocal(true)
        } else {
          Vue.prototype.$toast('请求服务器失败，请尝试重启客户端！！')
        }
        return Promise.reject(data.data.msg)
      }
      //token过期
      if (data.data.code === 305){
        Vue.prototype.$toast('登录已失效，请重新登录！！')
        
        console.log(3434343)
        store.dispatch("logout").then(() => {
          // location.reload(); // 为了重新实例化vue-router对象 避免bug
        });
        router.push('/mobile')
        // store.dispatch('logout')
      }
      if (data.data.code !== 0 || data.data.code !== 600) {
        // 排队机制
        // token失效
        if (data.data.code === 100) {
          store.dispatch('logout')
        } else if (data.status === 200 && !data.data.code) {
          return data.data
        } else if (data.data.msg == '暂无空闲机器，请稍后再试！！') {
          data.data.code = 'ZWKXJQ'
          return data.data
        } else if(data.data.code == 601 || data.data.code ==203) {
          return data.data
        }else{
          if(data.data.code === 101){
            return data.data
          }else{
            Vue.prototype.$toast(data.data.msg)
            return Promise.reject(data.data.msg)
          }
          
        }
      } else {
        return data.data
      }
    },
    error => {
      store.state.loading = false
      let errMsg
      if (error.toString() === 'Cancel') {
        errMsg = '请求过于频繁,请等待'
      } else {
        errMsg = '请求服务器失败，请联系管理员!!!'
      }
      Vue.prototype.$toast(errMsg)
      return Promise.reject(errMsg)
    },
  )
} catch (err) {
  console.log(err)
}

export default service;